__turbopack_context__.v({
  "cta": "page-module-scss-module__5Md6Ra__cta",
  "ctaBtn": "page-module-scss-module__5Md6Ra__ctaBtn",
  "ctaBtnOutline": "page-module-scss-module__5Md6Ra__ctaBtnOutline",
  "ctaButtons": "page-module-scss-module__5Md6Ra__ctaButtons",
  "ctaContent": "page-module-scss-module__5Md6Ra__ctaContent",
  "ctaSub": "page-module-scss-module__5Md6Ra__ctaSub",
  "ctaTitle": "page-module-scss-module__5Md6Ra__ctaTitle",
  "hero": "page-module-scss-module__5Md6Ra__hero",
  "heroContent": "page-module-scss-module__5Md6Ra__heroContent",
  "heroImageWrap": "page-module-scss-module__5Md6Ra__heroImageWrap",
  "heroOverlay": "page-module-scss-module__5Md6Ra__heroOverlay",
  "heroSub": "page-module-scss-module__5Md6Ra__heroSub",
  "heroTitle": "page-module-scss-module__5Md6Ra__heroTitle",
  "heroWave": "page-module-scss-module__5Md6Ra__heroWave",
  "intro": "page-module-scss-module__5Md6Ra__intro",
  "introGrid": "page-module-scss-module__5Md6Ra__introGrid",
  "introImage": "page-module-scss-module__5Md6Ra__introImage",
  "introText": "page-module-scss-module__5Md6Ra__introText",
  "parallaxBreak": "page-module-scss-module__5Md6Ra__parallaxBreak",
  "parallaxImage": "page-module-scss-module__5Md6Ra__parallaxImage",
  "philosophy": "page-module-scss-module__5Md6Ra__philosophy",
  "philosophyContent": "page-module-scss-module__5Md6Ra__philosophyContent",
  "philosophyGrid": "page-module-scss-module__5Md6Ra__philosophyGrid",
  "philosophyVideo": "page-module-scss-module__5Md6Ra__philosophyVideo",
  "quote": "page-module-scss-module__5Md6Ra__quote",
  "roastery": "page-module-scss-module__5Md6Ra__roastery",
  "roasteryContent": "page-module-scss-module__5Md6Ra__roasteryContent",
  "roasteryGrid": "page-module-scss-module__5Md6Ra__roasteryGrid",
  "roasteryImage": "page-module-scss-module__5Md6Ra__roasteryImage",
  "sectionTitle": "page-module-scss-module__5Md6Ra__sectionTitle",
});
